/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["custom-page[_ngcontent-%COMP%]{min-height:calc(100vh - 70px)}.ads-page-top-host[_ngcontent-%COMP%]{margin-top:35px}"];
export { styles as styles };
